module.exports = __webpack_public_path__ + "static/media/aastha_jajoo.81be2921.png";